module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av542-11e4b6209d63c4da70bb65461880fa28.jpg";